import { Volume2, Sparkles, Loader2, X } from "lucide-react";

/**
 * Voice cloning modal — ElevenLabs Instant Voice Clone entry point.
 * All state lives in Studio.jsx; this is a pure presentation component.
 */
export const VoiceCloneModal = ({
  open,
  onClose,
  busy,
  name,
  onNameChange,
  onSubmit,
  fileRef,
}) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center bg-[#0A0A0A]/80 backdrop-blur-sm p-6"
      data-testid="voice-clone-modal"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div className="max-w-md w-full p-6 rounded-3xl bg-gradient-to-br from-[#1a1208] via-[#120E15] to-[#0d1f24] border border-[#E27D60]/40">
        <div className="flex items-center justify-between mb-2">
          <div className="font-mono-hy text-[10px] text-[#E27D60] flex items-center gap-1.5">
            <Volume2 className="w-3.5 h-3.5" /> VOICE CLONING · ElevenLabs IVC
          </div>
          <button onClick={onClose} data-testid="voice-clone-close" className="text-white hover:text-white transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <h2 className="font-display text-2xl text-white mb-2">Give it your voice.</h2>
        <p className="font-body text-sm text-[#D9D2BE] mb-4">
          Upload a clean 20-60 second sample of you speaking (mp3, wav, m4a). Every future bio narration will use your signature voice.
        </p>
        <label className="font-mono-hy text-[10px] text-white block mb-2">Voice name</label>
        <input
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder="e.g. My Studio Voice"
          maxLength={40}
          data-testid="voice-clone-name-input"
          className="w-full mb-4 px-3 py-2.5 bg-[#0A0A0A] border border-[#E27D60]/25 focus:border-[#E27D60] focus:outline-none rounded-xl font-body text-white placeholder:text-white"
        />
        <label className="font-mono-hy text-[10px] text-white block mb-2">Voice sample</label>
        <input
          ref={fileRef}
          type="file"
          accept="audio/*"
          data-testid="voice-clone-file-input"
          className="w-full mb-4 text-xs font-body text-[#D9D2BE] file:mr-3 file:py-2 file:px-4 file:rounded-full file:border-0 file:font-mono-hy file:text-[10px] file:bg-[#E27D60] file:text-white hover:file:bg-[#f26666]"
        />
        <div className="flex items-center gap-2">
          <button
            onClick={onSubmit}
            disabled={busy}
            data-testid="voice-clone-submit-btn"
            className="flex-1 font-mono-hy text-xs px-5 py-3 rounded-full bg-[#E27D60] text-white hover:bg-[#f26666] transition-all disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {busy ? <><Loader2 className="w-3.5 h-3.5 animate-spin" /> Cloning…</> : <><Sparkles className="w-3.5 h-3.5" /> Clone Voice</>}
          </button>
          <button
            onClick={onClose}
            data-testid="voice-clone-cancel-btn"
            className="font-mono-hy text-xs px-5 py-3 rounded-full border border-[#F2C94C]/25 text-white hover:text-white hover:border-[#F2C94C]/50 transition-all"
          >
            Cancel
          </button>
        </div>
        <p className="font-mono-hy text-[9px] text-white mt-3 leading-relaxed">
          ⓘ ElevenLabs will process your sample. Uses your Instant Voice Clone quota — one active clone per user (previous ones are replaced).
        </p>
      </div>
    </div>
  );
};
